var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.tips ? 'tips_box active_revel' : 'tips_box'},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips_wirte"},[_c('div',{staticClass:"tips_title"},[_c('p',[_vm._v("Your NFTs have been revealed.")]),_c('p',[_vm._v("Visit your OpenSea NFT pages and click")]),_c('p',[_vm._v("“Refresh metadata”.")])])])
}]

export { render, staticRenderFns }